import { ScheduledCommand } from "../Model/ScheduledCommand";

export class GetScheduledCommandsList {
    constructor(
      scheduledCommands,
    ) {
        this.scheduledCommands = scheduledCommands;
    }
    static createFromResponseData(data) {
      return new GetScheduledCommandsList(
        data.map((record) => {
          return ScheduledCommand.createFromResponseData(record);
        }),
      );
    }
  };